import cx from 'classnames';
import Tooltip from 'js/components/elements/mui/Tooltip';
import { ReactComponent as DeleteIcon } from 'new/components/icons/fi-sr-cross-circle.svg';
import React, { useEffect, useState } from 'react';
import { Button } from '../Button';
import styles from './TwoStepDeleteButton.module.scss';

interface TwoStepDeleteButtonProps {
  index: number;
  onDeleteGroup: (index: number) => void;
}

export const TwoStepDeleteButton = (props: TwoStepDeleteButtonProps) => {
  const { index, onDeleteGroup } = props;
  const [expanded, setExpanded] = useState(false);
  const [showRemoveText, setShowRemoveText] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (expanded) {
      setShowRemoveText(true);
    } else {
      timeout = setTimeout(() => {
        setShowRemoveText(false);
      }, 200);
    }
    return () => clearTimeout(timeout);
  }, [expanded]);

  const handleDeleteGroup = () => {
    setExpanded(false);
    onDeleteGroup(index);
  };

  return (
    <div className={styles.buttonContainer}>
      <Button
        size="small"
        className={cx(styles.deleteButton, {
          [styles.expanded]: expanded,
        })}
        onClick={expanded ? handleDeleteGroup : () => setExpanded(true)}
        onMouseLeave={() => setExpanded(false)}
      >
        {showRemoveText ? (
          'Remove'
        ) : (
          <Tooltip title="Remove Transform">
            <DeleteIcon />
          </Tooltip>
        )}
      </Button>
    </div>
  );
};
